import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { AvailabilityFactory } from '../../availability/AvailabilityFactory';
import { AccountHolder } from "@tlc/ls2pac/components/Account";


export const LS2PAC_Utils = (function ( $ ) {

	return {
		isResourceAvailableLocally:              function ( resource ) {
			var _currentBranch = ApplicationData.getBranchToUseForAvailability(),
				local = false;

			resource.availableLocally = false;
			$.each( resource.holdingsInformations, function ( index, holding ) {
				if( holding.available == true ) {
					if( _currentBranch == parseInt(holding.branchIdentifier, 10) ) {
						resource.availableLocally = true;
						local = true;
						return false;
					}
				}
			} );
			return local;
		},
		isEveryItemAvailableLocally:              function ( resource ) {
			var _currentBranch = ApplicationData.getBranchToUseForAvailability(),
				local = true;

			resource.availableLocally = true;
			$.each( resource.holdingsInformations, function ( index, holding ) {
				if( !holding.available || (holding.available && _currentBranch != parseInt(holding.branchIdentifier, 10))) {
					resource.availableLocally = false;
					local = false;
					return false;
				}
			} );
			return local;
		},
		getFakePagingDataToSendToFullDetails:    function ( resources, index ) {
			//full details expects paged data.  If you need to send a list of resources to full details that doesn't have 'pages' then you can use this to fake it
			index = index || 0;
			var data = {
				index:        index,
				resourceData: {totalPages: 1, currentPage: 1, resources: resources}
			};
			// TODO note QA impact
			// data.resourceData = $.extend( data.resourceData, LS2PacSearchDatabaseManager.getCurrentDatabaseConfig() );
			return data;
		},
		getAvailabilityLink:                     function ( data ) {
			if( data.downloadable && data.link ) {
				return 'href="' + data.link + '"';
			}
			return "";
		},
		getQualifiedSearchTerm:                  function ( term, type ) {
			if( type === 'title' ||
				type === 'author' ||
				type === 'subject' ||
				type === 'seriestitle' ||
				type === 'authorsuggestion' ||
				type === 'tag' ||
				type === 'isbn' ||
				type === 'CallNumber'
			) {
				term = ApplicationData.getSearchTypeHash( type ).type + ':"' + term + '"';
			}
			if(typeof term === "object"){
				return JSON.stringify(term);
			}

			return term;
		},
		isSearchTermAnObject:                    function ( term ) {
			try {

				if(term === null){
					return false;
				}

				if (typeof term === "object" ) {
					return true;
				}

				var result = JSON.parse( term );
				if(typeof result === "object" ) {
					return true;
				}

				return false;
			}  catch (e) {
				return false;
			}

		},
		getLegitAvailableCopiesLength:           function ( holdingsInformations ) {
			return $.grep( holdingsInformations,
				function ( holding, index ) {
					return ((holding.available) && (holding.nonCirculating == false));
				} ).length;
		},
		getAvailabilityDisplayObject:            function ( resource ) {
			return AvailabilityFactory.displayAvailability( "", resource );
		},
		isValidPatronIdUser:                     function ( user ) {
			return (user.patronId !== undefined && user.patronId !== null && user.patronId > "");
		},
		setDisableRequestButton: function(resource, allowHolds, showBookings) { // Resource Object only (no Array)
			resource.holdingsInformations = resource.holdingsInformations || [];

			if (resource.serial) {
				LS2PAC_Utils.isEveryItemAvailableLocally(resource);
			} else {
				LS2PAC_Utils.isResourceAvailableLocally(resource);
			}

			if (((resource.availableLocally && !allowHolds.onShelf) && !showBookings) || resource.holdingsInformations.length == 0) { // could be eResource?
				resource.disableRequestButton = true;
			}
		},
		showRequestButton:                       function ( resource ) { // Resource Object or Array of Resource Objects

			if( AccountHolder.isAdmin ) {
				return false;
			}
			var supportsAvailability = ApplicationData.supportedFunctionality.supportsAvailabilityFunctionality,
				showBookings = ApplicationData.locationConfiguration.getAllowBookings(),
				allowHolds = ApplicationData.locationConfiguration.getAllowHolds();

			if( !supportsAvailability ) {
				return false;
			}

			if( (allowHolds.item || allowHolds.title || showBookings) && resource ) {

				if(Array.isArray(resource)) {

					if( resource.length === 0 ) { //empty Array
						return false;
					}

					if( resource.length > 1 ) { // batch
						return true;
					}

					if (resource[0].serial && !allowHolds.item) { // must use item level holds for a serial item
						return false;
					}

					LS2PAC_Utils.setDisableRequestButton( resource[0], allowHolds, showBookings );

				}
				else {
					if (resource.serial && !allowHolds.item) { // must use item level holds for a serial item
						return false;
					}

					LS2PAC_Utils.setDisableRequestButton( resource, allowHolds, showBookings );

				}

				return true;
			}
			else {
				return false;
			}
		},
		showDownloadButton:                      function () {
			if( AccountHolder.isAdmin ) {
				return;
			}
			return true;
		},
		convertPenniesToCurrency:                function ( inString ) {
			if( inString === null || inString === undefined ) {
				return "0.00";
			}
			inString = inString + "";

			var newVal = 0;
			//if there is a negative symbol remove and save
			var negativeSign = inString.indexOf( "-" );
			inString = Math.abs( inString );
			if( inString === 0 ) {
				return newVal;
			} else if( inString < 10 ) {
				newVal = "0.0" + inString;
			} else if( inString >= 10 && inString < 100 ) {
				newVal = "0." + inString;
			} else if( inString >= 100 ) {
				var str = inString + "";
				var dec = str.substring( str.length - 2 );
				var num = str.substring( 0, str.length - 2 );
				newVal = num + "." + dec;
			}
			if( negativeSign != -1 ) {
				newVal = "-" + newVal;
			}
			return newVal;
		},
		convertBookingsData:                     function ( data ) {
			$.each( data, function ( index, booking ) {
				booking.whenBookedForString = new Date( booking.whenBookedFor ).format( ApplicationData.language.dateFormat );
				booking.whenDueBackString = new Date( booking.whenDueBack ).format( ApplicationData.language.dateFormat );
				var items = [];
				$.each( booking.components, function ( ind2, component ) {
					$.each( component.items, function ( ind3, item ) {
						items.push( item.title );
					} );
				} );
				booking.itemsString = items.join( ", " );
			} );
		},
		getDomainFromURL:                        function ( url ) {
			var m = url.match( /^http:\/\/[^/]+/ );
			return m ? m[0] : null;
		},
		isEmptyString:                           function ( input ) {
			return input.trim().length === 0;
		},
		getDateString:                           function ( date ) {
			if( typeof(date) == "string" ) {
				date = date.replace( /-/g, "/" );
			}
			return new Date( date ).format( ApplicationData.language.dateFormat );
		},
		downloadFile:                            function ( url ) {
			var hiddenIFrameID = LS2PAC_CONSTANTS.Ids.hiddenIFrameDownloader,
				iframe = document.getElementById( hiddenIFrameID );

			if( iframe === null ) {
				iframe = document.createElement( 'iframe' );
				iframe.id = hiddenIFrameID;
				iframe.style.display = 'none';
				document.body.appendChild( iframe );
			}

			iframe.src = url;
		}
	};

})( jQuery );

var dateFormat = function () {
	var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
		timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
		timezoneClip = /[^-+\dA-Z]/g,
		pad = function ( val, len ) {
			val = String( val );
			len = len || 2;
			while( val.length < len ) val = "0" + val;
			return val;
		};

	// Regexes and supporting functions are cached through closure
	return function ( date, mask, utc ) {
		var dF = dateFormat;

		// You can't provide utc if you skip other args (use the "UTC:" mask prefix)
		if( arguments.length == 1 && Object.prototype.toString.call( date ) == "[object String]" && !/\d/.test( date ) ) {
			mask = date;
			date = undefined;
		}

		// Passing date through Date applies Date.parse, if necessary
		date = date ? new Date( date ) : new Date;
		if( isNaN( date ) ) throw SyntaxError( "invalid date" );

		mask = String( dF.masks[mask] || mask || dF.masks["default"] );

		// Allow setting the utc argument via the mask
		if( mask.slice( 0, 4 ) == "UTC:" ) {
			mask = mask.slice( 4 );
			utc = true;
		}

		var _ = utc ? "getUTC" : "get",
			d = date[_ + "Date"](),
			D = date[_ + "Day"](),
			m = date[_ + "Month"](),
			y = date[_ + "FullYear"](),
			H = date[_ + "Hours"](),
			M = date[_ + "Minutes"](),
			s = date[_ + "Seconds"](),
			L = date[_ + "Milliseconds"](),
			o = utc ? 0 : date.getTimezoneOffset(),
			flags = {
				d:    d,
				dd:   pad( d ),
				ddd:  dF.i18n.dayNames[D],
				dddd: dF.i18n.dayNames[D + 7],
				m:    m + 1,
				mm:   pad( m + 1 ),
				mmm:  dF.i18n.monthNames[m],
				mmmm: dF.i18n.monthNames[m + 12],
				yy:   String( y ).slice( 2 ),
				yyyy: y,
				h:    H % 12 || 12,
				hh:   pad( H % 12 || 12 ),
				H:    H,
				HH:   pad( H ),
				M:    M,
				MM:   pad( M ),
				s:    s,
				ss:   pad( s ),
				l:    pad( L, 3 ),
				L:    pad( L > 99 ? Math.round( L / 10 ) : L ),
				t:    H < 12 ? "a" : "p",
				tt:   H < 12 ? "am" : "pm",
				T:    H < 12 ? "A" : "P",
				TT:   H < 12 ? "AM" : "PM",
				Z:    utc ? "UTC" : (String( date ).match( timezone ) || [""]).pop().replace( timezoneClip, "" ),
				o:    (o > 0 ? "-" : "+") + pad( Math.floor( Math.abs( o ) / 60 ) * 100 + Math.abs( o ) % 60, 4 ),
				S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
			};

		return mask.replace( token, function ( $0 ) {
			return $0 in flags ? flags[$0] : $0.slice( 1, $0.length - 1 );
		} );
	};
}();

// Some common format strings
dateFormat.masks = {
	"default":      "ddd mmm dd yyyy HH:MM:ss",
	shortDate:      "m/d/yy",
	mediumDate:     "mmm d, yyyy",
	longDate:       "mmmm d, yyyy",
	fullDate:       "dddd, mmmm d, yyyy",
	shortTime:      "h:MM TT",
	mediumTime:     "h:MM:ss TT",
	longTime:       "h:MM:ss TT Z",
	isoDate:        "yyyy-mm-dd",
	isoTime:        "HH:MM:ss",
	isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
	isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};

// Internationalization strings
dateFormat.i18n = {
	dayNames:   [
		"Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
		"Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
	],
	monthNames: [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
		"January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November",
		"December"
	]
};

// TODO get rid of this prototype polution
// Used by DateControl in RequestsView which we may no longer need
Date.prototype.format = function ( mask, utc ) {
	return dateFormat( this, mask, utc );
};

Date.prototype.SubtractMonth = function ( numberOfMonths ) {
	var d = this;
	d.setMonth( d.getMonth() - numberOfMonths );
	if( d.getDate() > 27 ) {
		d.setDate( 27 );
	}
	return d;
};

Date.prototype.AddMonth = function ( numberOfMonths ) {
	var d = this;
	d.setMonth( d.getMonth() + numberOfMonths );
	if( d.getDate() > 27 ) {
		d.setDate( 27 );
	}
	return d;
};
